module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/estimate_2-60f06b0a5981c9b1e47a8d7f03489150.jpg";